import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

// Pages
import Dashboard from "./pages/Dashboard";
import AuthPage from "./auth";
import ListRolesPage from "./pages/phan-quyen/ListRoles";
import FormRolesPage from "./pages/phan-quyen/FormRoles";
import DanhSachKhachHang from "./pages/khach-hang-cua-toi/DanhSachKhachHang";
import DanhSachTaiKhoan from "./pages/tai-khoan/DanhSachTaiKhoan";
import DanhSachDuAn from "./pages/san-pham/du-an/DanhSachDuAn";
import DanhSachBangHang from "./pages/san-pham/bang-hang/DanhSachBangHang";
import DanhSachChuDauTu from "./pages/san-pham/chu-dau-tu/DanhSachChuDauTu";
import FormDuAn from "./pages/san-pham/du-an/FormDuAn";
import ImportBangHang from "./pages/san-pham/bang-hang/ImportBangHang";
import XemBangHang from "./pages/san-pham/bang-hang/XemBangHang";
import FormTaiKhoan from "./pages/tai-khoan/FormTaiKhoan";
import PipelineSetting from "./pages/settings/PipelineSetting";
import PipelineForm from "./pages/settings/PipelineForm";
import TagsSetting from "./pages/settings/TagsSetting";
import TagsForm from "./pages/settings/TagsForm";
import BangHangSettings from "./pages/settings/BangHangSettings";
import BangHangSettingsForm from "./pages/settings/BangHangSettingsForm";
import KhachHangDaChot from "./pages/khach-hang-da-chot/KhachHangDaChot";
import MyProfile from "./pages/Profile/MyProfile";
import ListCampaign from "./pages/campaign/ListCampaign";
import FormCampaign from "./pages/campaign/FormCampaign";
import ListGdKh from "./pages/giao-dich-khach-hang/ListKhachHang";
import FormGdKh from "./pages/giao-dich-khach-hang/FormKhachHang";
import ListTransactions from "./pages/giao-dich-khach-hang/ListTransactions";
import FormTransactions from "./pages/giao-dich-khach-hang/FormTransactions";
import Formbanghang from "./pages/san-pham/bang-hang/FormBangHang";

// Component kiểm tra login
const RequireAuth = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const currentUrl = location.pathname + location.search;

  return user ? (
    children
  ) : (
    <Navigate to={`/auth/login?redirect=${encodeURIComponent(currentUrl)}`} replace />
  );
};

function App() {
  const { user } = useSelector((state) => state.auth);

  return (
    <Router>
      <Routes>

        {/* Auth (login/register) */}
        <Route path="/auth/*" element={<AuthPage />} />
        <Route path="/xem-bang-hang/:id" element={<XemBangHang />} />

        {/* Dashboard - yêu cầu login */}
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/users" element={<RequireAuth><DanhSachTaiKhoan /></RequireAuth>} />
        <Route path="/add-users" element={<RequireAuth><FormTaiKhoan /></RequireAuth>} />
        <Route path="/edit-users/:id" element={<RequireAuth><FormTaiKhoan /></RequireAuth>} />

        {/* Roles - yêu cầu login */}
        <Route path="/khach-hang-cua-toi" element={<RequireAuth><DanhSachKhachHang /></RequireAuth>} />

        <Route path="/khach-hang-da-chot" element={<RequireAuth><KhachHangDaChot /></RequireAuth>} />

        <Route path="/roles" element={<RequireAuth><ListRolesPage /></RequireAuth>} />
        <Route path="/add-roles" element={<RequireAuth><FormRolesPage /></RequireAuth>} />
        <Route path="/edit-roles/:id" element={<RequireAuth><FormRolesPage /></RequireAuth>} />
        
        <Route path="/pipeline_settings" element={<RequireAuth><PipelineSetting /></RequireAuth>} />
        <Route path="/add-pipeline_settings" element={<RequireAuth><PipelineForm /></RequireAuth>} />
        <Route path="/edit-pipeline_settings/:id" element={<RequireAuth><PipelineForm /></RequireAuth>} />

        <Route path="/tags_settings" element={<RequireAuth><TagsSetting /></RequireAuth>} />
        <Route path="/add-tags_settings" element={<RequireAuth><TagsForm /></RequireAuth>} />
        <Route path="/edit-tags_settings/:id" element={<RequireAuth><TagsForm /></RequireAuth>} />

        <Route path="/du-an" element={<RequireAuth><DanhSachDuAn /></RequireAuth>} />
        <Route path="/add-duan" element={<RequireAuth><FormDuAn /></RequireAuth>} />
        <Route path="/edit-duan/:id" element={<RequireAuth><FormDuAn /></RequireAuth>} />

        <Route path="/bang-hang" element={<RequireAuth><DanhSachBangHang /></RequireAuth>} />
        <Route path="/import-banghang" element={<RequireAuth><ImportBangHang /></RequireAuth>} />
        <Route path="/add-banghang" element={<RequireAuth><Formbanghang /></RequireAuth>} />
        <Route path="/edit-banghang/:id" element={<RequireAuth><Formbanghang /></RequireAuth>} />

        <Route path="/banghang_settings" element={<RequireAuth><BangHangSettings /></RequireAuth>} />
        <Route path="/add-banghang_settings" element={<RequireAuth><BangHangSettingsForm /></RequireAuth>} />
        <Route path="/edit-banghang_settings/:id" element={<RequireAuth><BangHangSettingsForm /></RequireAuth>} />

        <Route path="/chu-dau-tu" element={<RequireAuth><DanhSachChuDauTu /></RequireAuth>} />
        <Route path="/add-chudautu" element={<RequireAuth><FormDuAn /></RequireAuth>} />
        <Route path="/edit-chudautu/:id" element={<RequireAuth><FormDuAn /></RequireAuth>} />

        <Route path="/campaign" element={<RequireAuth><ListCampaign /></RequireAuth>} />
        <Route path="/add-campaign" element={<RequireAuth><FormCampaign /></RequireAuth>} />
        <Route path="/edit-campaign/:id" element={<RequireAuth><FormCampaign /></RequireAuth>} />

        <Route path="/khach-hang" element={<RequireAuth><ListGdKh /></RequireAuth>} />
        <Route path="/add-customers" element={<RequireAuth><FormGdKh /></RequireAuth>} />
        <Route path="/edit-customers/:id" element={<RequireAuth><FormGdKh /></RequireAuth>} />

        <Route path="giao-dich" element={<RequireAuth><ListTransactions /></RequireAuth>} />
        <Route path="/add-transactions" element={<RequireAuth><FormTransactions /></RequireAuth>} />
        <Route path="/edit-transactions/:id" element={<RequireAuth><FormTransactions /></RequireAuth>} />

        <Route path="/profile" element={<RequireAuth><MyProfile /></RequireAuth>} />

        {/* Mặc định: chuyển sang dashboard nếu login, ngược lại về login */}
        <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Navigate to="/auth/login" replace />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
